import { render, staticRenderFns } from "./WorkspaceItem.vue?vue&type=template&id=26bdaf00&"
import script from "./WorkspaceItem.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports